export const USERS_ROOT = 'v1/users';
export const USERS_RESET_ENDPOINT = '/resetPassword';
export const USERS_REACTIVATE = 'reactivate';
export const USERS_ACTIVATE = 'activate';
export const USERS_DEACTIVATE = 'deactivate';
export const USERS_EXPIRE_PASSWORD = 'expirePassword';
